var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Redemption History" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "pb-6 flex justify-between items-center" },
                      [
                        _c("div", { staticClass: "flex items-center" }, [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("date-range-picker", {
                                ref: "picker",
                                attrs: {
                                  timePicker: false,
                                  showDropdowns: false,
                                  "max-date": _vm.maxDate,
                                  opens: "right",
                                  "auto-apply": true
                                },
                                on: { update: _vm.onChangeDate },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function(picker) {
                                      return [
                                        _vm._v(
                                          "\n                  From: " +
                                            _vm._s(
                                              _vm.moment(picker.startDate)
                                            ) +
                                            " - To: " +
                                            _vm._s(_vm.moment(picker.endDate)) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.dateRange,
                                  callback: function($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "search" },
                                on: { change: _vm.search },
                                model: {
                                  value: _vm.filter.q,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "q", $$v)
                                  },
                                  expression: "filter.q"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "data-tables-server",
                      {
                        ref: "tableTransaction",
                        attrs: {
                          data: _vm.data,
                          total: _vm.total,
                          "pagination-props": {
                            background: true,
                            pageSizes: [_vm.displayingItem]
                          }
                        },
                        on: { "query-change": _vm.onChangeTable }
                      },
                      _vm._l(_vm.titles, function(title) {
                        return _c("el-table-column", {
                          key: title.prop,
                          attrs: {
                            prop: title.prop,
                            label: title.label,
                            sortable: "custom"
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b115eec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b115eec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RedemptionHistory.vue
// module id = null
// module chunks = 